/* eslint-disable no-nested-ternary */
/* eslint-disable no-magic-numbers */
// IOS结果页
import React, { useState, useEffect, useMemo } from 'react'
import styles from './fenqile.module.scss'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { RootState } from '@/store'
import Icon from '@/components/icon/icon'

interface Props {
  productName?: '', // 产品名字
  applyStatus?: number, // hold单状态
  isMultiProduct:boolean // 判断是否为多产品
}


const IosSkin: React.FC<Props> = props => {
  const { productName, applyStatus, isMultiProduct } = props
  const { channelValue } = useSelector((state: RootState) => state.channel)
  // 判断是否是麦吉优由于麦吉优需要特殊处理，匹配结果页不能展示其他任何内容，所以将它的结果页分配到分期乐页面
  // useEffect(() => {
  //   if (channelValue === 'hbjf') {
  //     document.title = '\u200B'
  //   }
  // }, [])

  const youqianLogoText = useMemo(() => {
    switch (true) {
      case channelValue?.includes('juhaojie'):
        return <Icon type="jufu-haier-text-logo" className={styles.youqianTextLogoSvg}></Icon>
      case channelValue?.includes('jurongyi'):
        return <Icon type="jufu-jurongyi-text-logo" className={styles.youqianTextLogoSvg}></Icon>
      case channelValue?.includes('jufu'):
        return <img className={styles.youqianLogoText} src={require('@imgs/jufu/title.png')} alt="youqian-text" />
      default:
        return <Icon type="jufu-jurongyi-text-logo" className={styles.youqianTextLogoSvg}></Icon>
    }
  }, [channelValue])

  // 结果页logo
  const youqianLogo = useMemo(() => {
    switch (true) {
      case channelValue?.includes('juhaojie'):
        return <img className={styles.logo} style={{ borderRadius: '5px' }} src={require('@imgs/jufu/jufuLogo.jpg')} alt="logo" />
      case channelValue?.includes('jurongyi'):
        return <img className={styles.logo} style={{ borderRadius: '5px' }} src={require('@imgs/jufu/jurongyiLogo.png')} alt="logo" />
      default:
        return <img className={styles.logo} style={{ borderRadius: '5px' }} src={require('@imgs/jufu/jurongyiLogo.png')} alt="logo" />
    }
  }, [channelValue])

  return (
    <div className={styles.iosSkin}>
      <div className={styles.main} style={{
        backgroundImage: `url(${require('@imgs/jufu/result-backgroud.png')})`
      }}>
        {
          channelValue?.includes('mjy') || channelValue?.includes('hbjf') ? <></> : <div className={styles.logoBox}>
            {youqianLogo}
            <div className={styles.logoBoxRight}>
              {youqianLogoText}

              <img className={styles.logoText2} src={require('@imgs/register/new-theme/logo-subtitle.png')} alt="正规品牌 真实可信" />
            </div>
          </div>
        }
        {
          productName || channelValue?.includes('noMate') ? <>
            <div className={styles.applyResultBox}>
              <img className={styles.applyResultBoxIcon} src={require('@imgs/ios-skin/success.png')} alt="success" />
              {
                applyStatus === 8 ? <>
                  <div className={styles.applyResultBoxRight}>
                    <div className={styles.applyResultBoxText1}>恭喜, <span className={styles.applyPrductionName}>{!channelValue?.includes('noMate') && !isMultiProduct && productName}</span>匹配成功！</div>
                    <div className={styles.applyResultBoxText2}>审核人员将在<span className={styles.highlight}>工作时间来电</span>完成审核</div>
                  </div>
                </> : <>
                  <div className={styles.applyResultBoxRight}>
                    <div className={styles.applyResultBoxText1}>恭喜, <span className={styles.applyPrductionName}>{!channelValue?.includes('noMate') && !isMultiProduct && productName}</span>申请成功！</div>
                    <div className={styles.applyResultBoxText2}>请留意审核人员来电，完成信息审核</div>
                  </div>
                </>
              }
            </div>
            <div className={classNames(styles.containers, styles.passBox)}>
              <div className={styles.containerItem}>
                <img className={styles.applyResultBoxIcon} src={require('@imgs/form-result/pass.png')} alt="pass" />
                <div className={styles.containerItemSuccessText}>预审通过</div>
              </div>
              <img className={styles.line} src={require('@imgs/form-result/line.png')} alt="line" />
              <div className={styles.containerItem}>
                <img className={styles.applyResultBoxIcon} src={require('@imgs/form-result/phone.png')} alt="phone" />
                <div className={styles.containerItemFailText}>请留意审核人员来电</div>
              </div>
            </div>
          </> : <>
            <div className={classNames(styles.containers, styles.failBox)}>
              <img className={styles.noPass} src={require('@imgs/form-result/no-pass.png')} alt="no-pass" />
              <div className={styles.failBoxText1}>预审未通过</div>
              <div className={styles.failBoxText2}>抱歉，您的预审未通过。</div>
              <div className={styles.failBoxText3}>请点击左上角进行退出</div>
            </div>
          </>
        }
      </div>
    </div>
  )
}

export default IosSkin
